/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { KreditvurderingDto as OkEgisServiceModelsDtoKreditvurderingDto } from '../models/OK/Egis/Service/Models/DTO/kreditvurdering-dto';
import { KreditVurderingRequest as OkEgisServiceModelsRequestKreditVurderingRequest } from '../models/OK/Egis/Service/Models/Request/kredit-vurdering-request';

@Injectable({
  providedIn: 'root',
})
export class KreditvurderingService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getKreditVurderingForServiceordre
   */
  static readonly GetKreditVurderingForServiceordrePath = '/api/v1/Kreditvurdering/GetKreditVurderingForServiceordre';

  /**
   * Get kreditvurdering for customer when creating an order.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKreditVurderingForServiceordre()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getKreditVurderingForServiceordre$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestKreditVurderingRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoKreditvurderingDto>> {

    const rb = new RequestBuilder(this.rootUrl, KreditvurderingService.GetKreditVurderingForServiceordrePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoKreditvurderingDto>;
      })
    );
  }

  /**
   * Get kreditvurdering for customer when creating an order.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getKreditVurderingForServiceordre$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getKreditVurderingForServiceordre(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestKreditVurderingRequest
  }): Observable<OkEgisServiceModelsDtoKreditvurderingDto> {

    return this.getKreditVurderingForServiceordre$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoKreditvurderingDto>) => r.body as OkEgisServiceModelsDtoKreditvurderingDto)
    );
  }

  /**
   * Path part for operation getKreditVurderingForServiceaftale
   */
  static readonly GetKreditVurderingForServiceaftalePath = '/api/v1/Kreditvurdering/GetKreditVurderingForServiceaftale';

  /**
   * Updates a single Anlaeg.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKreditVurderingForServiceaftale()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKreditVurderingForServiceaftale$Response(params: {
    okKundeAftaleNr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoKreditvurderingDto>> {

    const rb = new RequestBuilder(this.rootUrl, KreditvurderingService.GetKreditVurderingForServiceaftalePath, 'post');
    if (params) {
      rb.query('okKundeAftaleNr', params.okKundeAftaleNr, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoKreditvurderingDto>;
      })
    );
  }

  /**
   * Updates a single Anlaeg.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getKreditVurderingForServiceaftale$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKreditVurderingForServiceaftale(params: {
    okKundeAftaleNr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoKreditvurderingDto> {

    return this.getKreditVurderingForServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoKreditvurderingDto>) => r.body as OkEgisServiceModelsDtoKreditvurderingDto)
    );
  }

}
